import React from "react";

export default function SearchRow({ onChange }) {
  const fields = [
    "10MPXK",
    "maPhieuXuatKhoERP",
    "lenhXuatHangERP",
    "", // ppTuKho
    "", // ngayXuat
    "", // khoDen
    "", // donViPhanPhoi
    "", // SLT
    "", // slGhiNhan
    "", // SLGTBPP
    "", // SLGTBPXK
    "1BSPT",
    "2ĐDBX",
    "10NN",
    "", // ngayLapPhieu
    "lyDoXuatPXK",
    "", // SLGN
    "trangthaichuyen",
    "flag",
    "136NT",
    "nguonDongBoPXK",
  ];

  const handle = (name) => (e) => {
    const v = e.target.value;
    onChange?.({ [name]: v.trim() });
  };

  return (
    <tr>
      <td></td>
      <td></td>
      {fields.map((name, idx) =>
        name ? (
          <td key={idx}>
            <input
              className="form-control"
              type="text"
              onChange={handle(name)}
            />
          </td>
        ) : (
          <td key={idx}></td>
        )
      )}
      <td></td>
    </tr>
  );
}
